"use client";

import dynamic from "next/dynamic";

const CookieConsent = dynamic(
  () =>
    import("@/components/marketing/cookie-consent").then(
      (mod) => mod.CookieConsent,
    ),
  { ssr: false },
);

/**
 * Thin client wrapper that lazy-loads CookieConsent with ssr: false.
 * Keeps the root layout as a server component while deferring the
 * cookie banner JS until after hydration.
 */
export function LazyCookieConsent() {
  return <CookieConsent />;
}
